<template>
   <div v-loading="loading">
      <div class="search-wrapper">
         <el-form :inline="true" v-model="queryForm">
            <el-form-item label="类型">
               <el-select v-model="queryForm.type">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
                     :value="item.value"></el-option>
               </el-select>
            </el-form-item>
            <el-form-item label="状态">
               <el-select v-model="queryForm.status">
                  <el-option label="全部" :value="0"></el-option>
                  <el-option label="未发布" :value="1"></el-option>
                  <el-option label="已发布" :value="2"></el-option>
               </el-select>
            </el-form-item>
         </el-form>
         <el-button type="primary" @click="queryList">搜索</el-button>
      </div>

      <div class="action-wrapper">
         <el-button type="primary" @click="clickAddition">新增</el-button>
      </div>

      <div class="content-wrapper">
         <el-table :data="listData">
            <el-table-column align="center" label="序号" type="index" width="80"></el-table-column>
            <el-table-column align="center" label="类型">
               <template scope="{row}">{{ handleType(row) }}</template>
            </el-table-column>
            <el-table-column align="center" label="名称" prop="name"></el-table-column>
            <el-table-column align="center" label="图形" min-width="160">
               <template scope="{row}">
                  <div class="flex-row-center margin-bottom-10">
                     <img v-if="row.pictures.length > 0" class="table-img" :src="row.pictures[0].url" alt="">
                     <img v-if="row.pictures.length > 1" class="table-img" :src="row.pictures[1].url" alt="">
                  </div>
               </template>
            </el-table-column>
            <el-table-column align="center" label="文案">
               <template scope="{row}">
                  {{ row.copyWriter ? row.copyWriter.map((item) => item.content).join(';') : '' }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="链接" prop="url"></el-table-column>
            <el-table-column align="center" label="有效时间" width="180">
               <template scope="{row}">
                  {{ $util.dateFormat(new Date(row.startTime)) + ' - ' + $util.dateFormat(new Date(row.endTime)) }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="状态">
               <template scope="{row}">
                  {{ row.status == 2 ? '已发布' : '未发布' }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="最近操作时间">
               <template scope="{row}">
                  {{ $util.dateFormat(new Date(row.updateTime)) }}
               </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="180" fixed="right">
               <template scope="{row}">
                  <el-button v-if="row.status == 2" type="text" @click="clickDetail(row)">详情</el-button>
                  <el-button v-if="row.status == 1" type="text" @click="clickEdit(row)">编辑</el-button>
                  <el-button v-if="row.status == 1" type="text" @click="clickPublish(row)">发布</el-button>
                  <el-button v-if="row.status == 2" type="text" @click="clickRevoke(row)">撤销</el-button>
                  <el-button v-if="row.status == 1" type="text" style="color: red;"
                     @click="clickDelete(row)">删除</el-button>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <div class="pagination-wrapper">
         <el-pagination v-show="total > 0" layout="prev, pager, next" :current-page="queryForm.pageNum"
            :page-size='queryForm.pageSize' :total="total" @current-change="changeCurrentPage">
         </el-pagination>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
         loading: false,
         typeOptions: [
            { label: '全部', value: 0 },
            { label: '首页气泡', value: 1 },
            { label: '首页通知栏', value: 2 },
            { label: '首页顶部入口背景', value: 3 },
         ],
         queryForm: {
            type: 0,
            status: 0,
            pageNum: 1,
            pageSize: 20,
         },
         total: 0,
         listData: [],
      }
   },

   mounted() {
      this.queryList();
   },

   methods: {
      // 查询列表
      queryList() {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/home/config/list',
            method: 'POST',
            body: JSON.stringify(this.queryForm)
         }).then((res) => {
            this.total = res.data.data.count || 0;
            this.listData = res.data.data.configModelList || [];
         }).catch((err) => {
            this.total = 0;
            this.listData = [];
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送发布或撤销
      sendStatus(id, status) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/home/config/status',
            method: 'POST',
            body: JSON.stringify({ id, status })
         }).then((res) => {
            if (res.data.error === 10000) {
               this.queryList();
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 发送删除
      sendDelete(id) {
         this.loading = true;
         this.$http({
            url: this.$util.domain + '/adminapi/v1/yqb/home/config/del',
            method: 'POST',
            body: JSON.stringify({ id })
         }).then((res) => {
            if (res.data.error === 10000) {
               this.queryList();
               this.$util.successMsg(res.data.message);
            } else {
               this.$util.errorMsg(res.data.message);
            }
         }).catch((err) => {
            this.$util.errorMsg(err.message);
         }).finally(() => {
            this.loading = false;
         })
      },
      // 点击新增按钮
      clickAddition() {
         this.$router.push({
            path: '/yunying/advertising/pingan/home/config',
            query: { type: this.queryForm.type, actionType: 'add' }
         })
      },
      // 点击详情
      clickDetail(row) {
         this.$router.push({
            path: '/yunying/advertising/pingan/home/config',
            query: { type: row.type, actionType: 'detail', id: row.id }
         })
      },
      // 点击编辑
      clickEdit(row) {
         this.$router.push({
            path: '/yunying/advertising/pingan/home/config',
            query: { type: row.type, actionType: 'edit', id: row.id }
         })
      },
      // 点击发布
      clickPublish(row) {
         this.$confirm('是否确定发布？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendStatus(row.id, 2);
         }).catch(() => { });
      },
      // 点击撤销
      clickRevoke(row) {
         this.$confirm('是否确定撤销？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendStatus(row.id, 1);
         }).catch(() => { });
      },
      // 点击删除
      clickDelete(row) {
         this.$confirm('是否确定删除？', '温馨提示', {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: 'warning'
         }).then(() => {
            this.sendDelete(row.id)
         }).catch(() => { });
      },
      // 切换当前页码
      changeCurrentPage(val) {
         this.queryForm.pageNum = val;
         this.queryList();
      },
      // 处理类型
      handleType(row) {
         const option = this.typeOptions.find((item) => item.value === row.type);
         return option ? option.label : '';
      }
   },
}
</script>

<style scoped></style>


// WEBPACK FOOTER //
// HomeConfiguration.vue?492432da